<template>
  <gj-modal
      v-bind="$attrs"
      size="normal"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      :no-padding="true"
      @cancel="$emit('cancel')"
      @confirm="confirm()">
    <template #header>修改结束日期</template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
          style="margin: 20px 0;"
          label-width="200px">
        <el-form-item
            label="结束日期"
            prop="date"
            :rules="[
              { required: true, message: '请选择结束日期', trigger: ['blur', 'change'] }
            ]">
          <gj-date-picker
              v-model="form.date"
              :clearable="false"
              width="150px"
              :disabled-date="disabledEndDate"
          ></gj-date-picker>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {formRuleMixin, modalMixIn} from "@/minxins";
  import {disabledEndDate} from "@/utils/common";

  export default {
    name: "app-update-end-date-modal",
    mixins: [modalMixIn, formRuleMixin],
    data() {
      return {
        confirmLoading: false,
        form: {
          date: null
        },
        disabledEndDate: disabledEndDate(new Date())
      }
    },
    methods: {
      confirm() {
        if (this.$gjFormValidate()) {
          this.$emit('confirm');
        }
      }
    }
  }
</script>

<style scoped>
  .form-input {
  
  }
</style>
